import { render } from "./StatsInput.vue?vue&type=template&id=1597255b&scoped=true&ts=true"
import script from "./StatsInput.vue?vue&type=script&lang=ts"
export * from "./StatsInput.vue?vue&type=script&lang=ts"

import "./StatsInput.vue?vue&type=style&index=0&id=1597255b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1597255b"]])

export default __exports__